var youbora = require('youboralib')
var manifest = require('../manifest.json')
var Util = youbora.Util

youbora.adapters.JWPlayer7 = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getPosition()
  },

  getPlayrate: function () {
    if (this.player.getPlaybackRate) {
      return this.player.getPlaybackRate()
    }
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.duration || this.player.getDuration() || null
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var quality = this.player.getVisualQuality();
    if (typeof quality != 'undefined' && typeof quality.level != 'undefined' &&
      typeof quality.level.bitrate != 'undefined') {
      return quality.level.bitrate
    } else if (typeof this.player.getCurrentQuality() === "number" && this.player.getQualityLevels()
      && this.player.getCurrentQuality() != -1) {
      quality = this.player.getQualityLevels()[this.player.getCurrentQuality()]
      if (quality && quality.bitrate) {
        return quality.bitrate * 1000
      }
    }
    return -1
  },

  /** Override to return rendition */
  getRendition: function () {
    var quality = this.player.getVisualQuality()
    if (quality && quality.level) {
      return Util.buildRenditionString(
        quality.level.width,
        quality.level.height,
        quality.level.bitrate || 0
      )
    } else if (typeof this.player.getCurrentQuality() === "number" && this.player.getQualityLevels()) {
      quality = this.player.getQualityLevels()[this.player.getCurrentQuality()];
      if (quality && quality.label == 'auto') {
        return Util.buildRenditionString(quality.bandwidth)
      } else if (quality && quality.label) {
        return quality.label
      } else if (this.player.getCurrentQuality() === -1) {
        return 'auto'
      }
    }
    return null;
  },

  /** Override to return title */
  getTitle: function () {
    return this.title
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.isLive
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.getPlaylistItem().file
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return this.player.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'JWPlayer';
  },

  /** Set options using config */
  setOptions: function (e) {
    if (e && e.media) {
      this.isLive = e.media.isLive || this.isLive
      this.title = e.media.title || this.title
    }
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player, [
      'beforePlay', 'meta', 'playlistItem', 'setupError', 'idle', 'complete', 'buffer', 'firstFrame'
    ])

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // Register listeners
    this.references = []
    this.references['beforePlay'] = this.playListener.bind(this)
    this.references['play'] = this.timeupdateListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['error'] = this.errorListener.bind(this)
    this.references['seek'] = this.seekingListener.bind(this)
    this.references['seeked'] = this.seekedListener.bind(this)
    this.references['complete'] = this.endedListener.bind(this)
    this.references['meta'] = this.metaListener.bind(this)
    this.references['playlistItem'] = this.playlistItemListener.bind(this)
    this.references['setupError'] = this.setupErrorListener.bind(this)
    this.references['idle'] = this.idleListener.bind(this)
    this.references['firstFrame'] = this.firstFrameListener.bind(this)

    for (var key in this.references) {
      this.player.on(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.off(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'playlistItem' event. */
  playlistItemListener: function (e) {
    // reset private variables
    this.duration = undefined
    this.throughput = -1
    // Set options
    this.setOptions(this.player.getConfig().youbora)
    this.setOptions(this.player.getPlaylistItem().youbora)
  },
  /** Listener for 'setupError' event. */
  setupErrorListener: function (e) {
    this.fireError(e.message)
  },
  /** Listener for 'idle' event. */
  idleListener: function (e) {
    if (!e.reason || e.reason === "complete") this.fireStop()
  },
  /** Listener for 'firstFrame' event. */
  firstFrameListener: function (e) {
    this.fireJoin()
  },

  /** Listener for 'beforePlay' event. */
  playListener: function (e) {
    // reset private variables
    this.duration = undefined
    this.throughput = -1

    // Set options from config if playlist options are not defined
    // Playlist config has higher priority, they will be set in playlistItem event
    if (!this.player.getPlaylistItem().youbora) {
      this.setOptions(this.player.getConfig().youbora)
    }

    if (!this.flags.isStarted) {
      // Send /start
      this.fireStart()
      // Start adnalyzer
      if (this.plugin.getAdsAdapter() === null) {
        var adapter = new youbora.adapters.JWPlayer7.GenericAdsAdapter(this.player)
        this.plugin.setAdsAdapter(adapter)
      }
    }

  },

  /** Listener for 'play' event. */
  timeupdateListener: function (e) {
    this.fireResume()
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e.message)
  },

  /** Listener for 'seek' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'seeked' event. */
  seekedListener: function (e) {
    if (this.player.getState() != "paused")
      this.fireSeekEnd()
  },

  /** Listener for 'complete' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  /** Listener for 'meta' event */
  metaListener: function (e) {
    this.duration = e.duration || this.duration
    if (e.metadata) {
      this.duration = e.metadata.duration || this.duration
    }
  }
},
  {
    GenericAdsAdapter: require('./ads/native')
  }
)

module.exports = youbora.adapters.JWPlayer7



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 26
// module chunks = 0